import { createApp } from 'vue'
import App    from './App.vue'
import router from './router'
// Boss design system (source of truth): tokens first, then component classes.
// App.vue's later global <style> still wins for legacy .btn/.card during reskin.
import './assets/devtask/tokens.css'
import './assets/devtask/components.css'
import { applyLocale } from './composables/useI18n'
import { applyTheme }  from './composables/useTheme'

// Apply persisted language (dir/lang) + theme before mount to avoid a flash.
applyLocale()
applyTheme()

createApp(App).use(router).mount('#app')
